"use strict";

import * as App from '../app/app~fv=cw_byBD8.min.js';

/**
@typedef {import('../../../pkg/cozejs/typedef.js').Pay} Pay
@typedef {import('../../../pkg/cozejs/typedef.js').B64} B64
@typedef {import('../app/paginate.js').PagRec}          PagRec
 */

/**
Markdown is the main markdown object that holds the rendered md as HTML, and any
additional information needed for the page.

- html: Markdown text/file rendered as HTML. This is the only required field.
  This should be the full markdown body for the page.
- author: The author's uad.
- author_display_name: The author's display name.
- subject: Markdown subject, where the markdown body data is coming from. E.g.
  "comment" or "file".
- comment_pagrec: The Markdown page's pagination object for comments.
@typedef  {object}            Markdown
@property {HTMLBodyElement}   html
@property {string}            [subject]
@property {PagRec}            [comment_pagrec]
 */

/** @type {Markdown} */
var MD = {};

App.AddOnload(MarkdownOnload);

// Onload for the Markdown page.
async function MarkdownOnload() {
	console.debug("Executing MarkdownOnload: ", markdown);

	MD = {
		...markdown
	};

	/**@type {PagRec} */
	var pagrec = await App.InitPagRec(MD.comment_pagrec);
	console.debug(pagrec)


	document.getElementById('authorLink').href = '/user/id/' + MD.author;
	if (isEmpty(MD.updated)) {
		document.getElementById('updatedTime').textContent = 'n/a';
	}

	// TODO remove static id check once disable comment is implemented.
	// Comment and reviews.
	// Official blog page.
	// TODO Sync same ac and main blog czd for prod and dev.
	if (MD.id === "E_CZxGeK6LwbB3grsO8Tz5kO1-ckh4r1Xhw383v194k") {
		Hide('CommentSection');
		return;
	}
	Show('CommentSection');

	document.getElementById('submitCommentBtn').addEventListener('click', () => {
		let comment = {};
		comment.text = document.querySelector("#commentTextArea").value;
		comment.root = MD.id;
		// Parent must also be set, and be equal to root for top level comments,
		// since children are queried by parent, and not root.
		// comment.parent = MD.id;

		// console.debug(comment);
		App.SubmitComment(comment, true);
	});

	if (!isEmpty(MD.comment_pagrec && !isEmpty(MD.comment_pagrec.rec))) {
		App.ToggleReviewForm(MD.comment_pagrec.rec);
		App.CommentReviewModule(MD.comment_pagrec);
	}
}